import {
    TableResponse,
} from 'app/types/request.types'

const responseParser = {
    table: (
        promise: Promise<{ data: { matches?: any, items: any, hasNextPage?: boolean } }>,
    ): Promise<TableResponse> => {
        return promise.then((resp) => {
            return {
                meta: {
                    matchedresults: resp.data?.matches,
                },
                hasNextPage: resp.data?.hasNextPage,
                data: resp.data.items,
                matches: resp.data?.matches,
            }
        })
    },
    entity: <T, >(promise: Promise<{ data: T }>): Promise<T> => {
        return promise.then((resp) => {
            return resp.data
        })
    },
    items: <T, >(
        promise: Promise<{ data: { items: T[] } }>,
    ): Promise<T[]> => {
        return promise.then((resp) => {
            return resp?.data?.items
        })
    },
}

export default responseParser
